import React from "react";
import "../../Trip Details/css/AircraftDetails.css";
import ImageComponent from "../../Trip Details/views/ImageComponent";
import registrationNumberIcon from "../../../assets/images/registration_number_icon.svg";
import weightIcon from "../../../assets/images/aircraft_weight_icon.svg";

const getMtow = (tripData) => {
  return (
    tripData?.maxTakeOffWeight ?? "---"
  );
};

const UnregisteredAircraftTripAircraftDetails = ({ tripData }) => {
  return (
    <div className="aircraft-details-container">
      <p data-testid="aircraft-details-label">Aircraft Details</p>
      <div className="aircraft-details-box">
        <div className="aircraft-details-row">
          <div className="detail-item">
            <div className="detail-icon">
              <ImageComponent
                src={registrationNumberIcon}
                alt="Registration Number Icon"
              />
            </div>
            <div>
              <span className="detail-title">Registration Number</span>
              <label>{tripData?.aircraftRegistrationNumber ?? "-"}</label>
            </div>
          </div>

          <div className="detail-item">
            <div className="detail-icon">
              <ImageComponent src={weightIcon} alt="Aircraft Weight Icon" />
            </div>
            <div>
              <span className="detail-title">Maximum Takeoff Weight (lbs)</span>
              <label>{getMtow(tripData)}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnregisteredAircraftTripAircraftDetails;

